import React from 'react';
import PropTypes from 'prop-types';
import {
  Breadcrumbs,
  createTheme,
  Link,
  ThemeProvider,
  Typography,
  defaultTheme,
} from '@nextiva/next-ui-components';

import { getBreadcrumbs } from '../../breadcrumbs.config';

const Text = ({ children, className, component, href }) => {
  const Component = component;

  return (
    <Component
      className={className}
      href={href}
      data-testid="PlatformAdminUI-BreadCrumbs-Component"
    >
      {children}
    </Component>
  );
};

Text.propTypes = {
  component: PropTypes.elementType.isRequired,
  href: PropTypes.string.isRequired,
  children: PropTypes.string,
  className: PropTypes.string,
};

Text.defaultProps = {
  className: '',
  children: '',
};

const theme = createTheme(defaultTheme, {
  typography: {
    body1: {
      color: '#232649',
      fontFamily: "'Lato', sans-serif !important",
    },
  },
  overrides: {
    MuiLink: {
      root: {
        fontSize: '12px',
      },
    },
    MuiBreadcrumbs: {
      li: {
        fontSize: '12px',
        '& p': {
          fontSize: '12px',
        },
      },
      separator: {
        fontSize: '12px',
        marginLeft: '3px',
        marginRight: '3px',
      },
    },
  },
});

const BreadcrumbsWrapper = ({ config, pathname, className }) => {
  const { breadcrumbs = '', match = '' } =
    getBreadcrumbs(pathname, config) || {};

  if (!breadcrumbs) {
    return null;
  }

  if (match) {
    const value = sessionStorage.getItem(match);
    const shouldRender = value ? JSON.parse(value) : false;

    if (!shouldRender) {
      return null;
    }
  }

  let link = '#';
  const routes = [];
  const pathName = pathname.split('/').filter((el) => el !== '');

  breadcrumbs.forEach((breadcrumb, i) => {
    const segment = pathName[i];
    const [, , , TEAM_NAME] = pathName;

    link += `/${segment}`;
    let path = i < pathName.length - 1 ? link : '#';
    let title = breadcrumb;

    if (typeof breadcrumb === 'object') {
      if (breadcrumb.skip) return;

      title = breadcrumb.title || segment.replace('-', ' ');
      path = breadcrumb.path || path;
    }

    if (title === 'TEAM_NAME') {
      title = TEAM_NAME;
    }

    routes.push({ title, path });
  });

  return (
    <ThemeProvider theme={theme}>
      <Breadcrumbs
        className={className}
        aria-label="breadcrumb"
        data-testid="PlatformAdminUI-Header-Breadcrumbs"
      >
        {routes.map(({ title, path }, i, list) => {
          const isLastItem = i === list.length - 1;
          const isLink = !isLastItem && path;

          return (
            <Text
              component={isLink ? Link : Typography}
              href={path}
              key={i}
              data-testid="PlatformAdminUI-BreadcrumbsWrapper-Text"
            >
              {title}
            </Text>
          );
        })}
      </Breadcrumbs>
    </ThemeProvider>
  );
};

BreadcrumbsWrapper.propTypes = {
  pathname: PropTypes.string.isRequired,
  className: PropTypes.string,
};

BreadcrumbsWrapper.defaultProps = {
  className: '',
};

export default BreadcrumbsWrapper;
